import React from 'react';
import { Link } from 'react-router-dom';
import style from './MicrosoftButton.module.scss';

// Microsoft logo — 4-colour grid as per Microsoft branding guidelines.
// Rendered inline to avoid any external script dependency (consistent with XeroButton approach).
const MICROSOFT_LOGO = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
  </svg>
);

const MicrosoftButton = ({ label = 'Sign in with Microsoft', onClick }) => (
  <Link to="/auth/microsoft" className={style.microsoftButton} onClick={onClick}>
    <span className={style.microsoftLogo}>{MICROSOFT_LOGO}</span>
    <span className={style.microsoftButtonText}>{label}</span>
  </Link>
);

export default MicrosoftButton;
